<template>
  <div class="notfound">
    <h1>{{ heading }}</h1>
    <p>{{ description }}</p>
  </div>
</template>

<script>
export default {
  name: 'Privacy',
  data () {
    return {
      heading: '404',
      description: 'Not Found'
    }
  }
}
</script>

<style scoped>
p {
  color: gray;
}
</style>



// WEBPACK FOOTER //
// src/components/NotFound.vue